const zhCommon = {
  nav: {
    home: '首页',
    categories: '分类',
    popular: '热门',
    about: '关于我们',
    search: '搜索漫画...',
  },
  footer: {
    subscribeTitle: '订阅更新',
    subscribeDesc: '第一时间获取最新韩漫上架通知与独家推荐',
    subscribePlaceholder: '输入您的邮箱',
    subscribeBtn: '订阅',
    quickLinks: '快速链接',
    categories: '分类浏览',
    support: '帮助支持',
    contactTitle: '联系我们',
    contactEmail: 'hello@szshops.com',
    contactAddress: '韩国首尔特别市江南区',
    copyright: '© 2026 韩漫大全. 本站内容仅供学习交流使用。',
  },
  breadcrumb: {
    home: '首页',
    category: '分类',
    comic: '作品详情',
    about: '关于我们',
  },
  general: {
    readMore: '阅读更多',
    viewAll: '查看全部',
    loading: '加载中...',
    noData: '暂无数据',
    submitSuccess: '订阅成功！感谢您的关注。',
    submitError: '提交失败，请稍后重试。',
  },
};

export default zhCommon;